import { HttpClient } from '@angular/common/http';
import { ElementRef, Injectable } from '@angular/core';
import { identity } from 'rxjs';
import { map } from 'rxjs/operators';
// //produccion
// // import { environment } from 'src/environments/environment.prod';
// //desarrollo
import { environment } from 'src/environments/environment';
import { Vtiger_WSClient } from './WSClient';

@Injectable({
  providedIn: 'root',
})

export class VtigerService {
  sessionid?: string = localStorage.getItem('sessionid');
  wsclient = new Vtiger_WSClient(this.wsUrl);

  constructor(private http: HttpClient) {
    this.wsclient._sessionid = this.sessionid;
  }

  login(
    user: string,
    pass: string,
  ) {
    return new Promise((resolve) => {
      this.wsclient.doLogin(user, pass,(res: any) => {
        if (res) {
          localStorage.setItem('contactid', '12x' + this.wsclient._contactid);
          localStorage.setItem('userid', this.wsclient._userid);
          resolve({ success: res, sessionid: this.wsclient._sessionid });
        } else resolve({ success: false, error: this.wsclient.lastError() });
      });
    })
  }

  testSession() {
    return new Promise((resolve) => {
      this.wsclient.doDescribe('Contacts', (res: any) => {
        if (res) resolve({ success: true });
        else resolve({ success: false });
      });
    })
  }

  describeModules() {
    return new Promise((resolve) => {
      this.http.get('assets/json/module.json').pipe(
        map((res: any) => {
          return res;
        })
      ).subscribe((val) => {
        this.wsclient.doInvoke((response: any) => {
          resolve({ success: true, result: response, labels: val.labels });
        },
          'lpdescribe',
          { elementTypes: JSON.stringify(val.modules) },
          'POST');
      });
    })
  }

  getRecords(type?: string) {
    var contacto = localStorage.getItem('contactid');
    return new Promise((resolve) => {
      this.wsclient.doInvoke((res: any) => {
        if (res) {
          resolve({ success: true, result: res });
        } else {
          resolve({ success: false, error: this.wsclient.lastError() });
        }
      },
        'lpretrieve_related',
        {
          sourceid: contacto,
          relatedType: type,
          relatedLabel: type
        },
        'POST'
      );
    });
  }

  getUsers(id?: string) {
    return new Promise((resolve) => {
      this.wsclient.doInvoke((res: any) => {
        console.log(res);
        if (res) {
          resolve({ success: true, result: res });
        } else {
          resolve({ success: false, error: this.wsclient.lastError() });
        }
      },
        'retrieve',
        {
        id:id,
        },
        'GET'
      );
    });
  }

  create(type?: string, entity?:any) {
    return new Promise((resolve) => {
      this.wsclient.doCreate(type,entity, (res:any) => {
        if (res) {
          resolve({ success: true, result: res });
        } else {
          resolve({ success: false, error: this.wsclient.lastError() });
        }
      });
    });
  }

  revise(entity?: any) {
    return new Promise((resolve) => {
      this.wsclient.doInvoke((res: any) => {
        if (res) {
          resolve({ success: true, result: res });
        } else {
          resolve({ success: false, error: this.wsclient.lastError() });
        }
      },
        'revise',
        {
          element: entity
        },
        'POST'
      );
    });
  }
  
  lprecuperar_psw(email: any, codigo:any) {
    return new Promise((resolve) => {
      this.wsclient.doInvoke((res: any) => {
        if (res) {
          resolve({ success: true, result: res });
        } else {
          resolve({ success: false, error: this.wsclient.lastError() });
        }
      },
        'lprecuperar_psw',
        {
         email: email,
         codigo: codigo
        },
        'GET'
      );
    });
  }
   

lpchange_password(correo: string, pwd: string, pwdNew: string | null = null) {
  return new Promise((resolve) => {
    this.wsclient.doInvoke((res: any) => {
      // el WS ahora devuelve { success, message }
      if (res && typeof res.success !== 'undefined') {
        resolve(res);
      } else if (res) {
        resolve({ success: true, result: res }); // fallback si otro WS devuelve algo viejo
      } else {
        resolve({ success: false, error: this.wsclient.lastError() });
      }
    },
    'lpchange_password',
    { correo, pwd, pwdNew },
    'POST');
  });
}
updateEmailAndUsername(payload: { contactid: string; newEmail: string }) {
  return new Promise((resolve) => {
    this.wsclient.doInvoke((res: any) => {
      // Esperamos { success, message }
      if (res && typeof res.success !== 'undefined') resolve(res);
      else if (res) resolve({ success: true, result: res });
      else resolve({ success: false, error: this.wsclient.lastError() });
    },
    'update_email_username',       // nombre publicado del WS anterior
    payload,
    'POST');
  });
}



  changePassword(id?: any, oldPassword?: any,newPassword?: any,confirmPassword?: any,user?: any) {
    return new Promise((resolve) => {
      this.wsclient.doInvoke((res: any) => {
        if (res) {
          resolve({ success: true, result: res });
        } else {
          resolve({ success: false, error: this.wsclient.lastError() });
        }
      },
        'changePassword',
        {
          id: id, 
          oldPassword: oldPassword, 
          newPassword: newPassword, 
          confirmPassword: confirmPassword, 
          username: user,
        },
        'POST'
      );
    });
  }

  lpdownloadfile(file:any) {
    return new Promise((resolve) => {
      this.wsclient.doInvoke((res: any) => {
        if (res) {
          resolve({ success: true, result: res });
        } else {
          resolve({ success: false, error: this.wsclient.lastError() });
        }
      },
        'lpdownloadfile',
        {
         file: file,
        },
        'GET'
      );
    });
  }

  download_file(id?: any) {
    var contacto = (localStorage.getItem('contactid')).split("x")[1];
    console.log(contacto)
    return new Promise((resolve) => {
      this.wsclient.doInvoke((res: any) => {
        if (res) {
          resolve({ success: true, result: res });
        } else {
          resolve({ success: false, error: this.wsclient.lastError() });
        }
      },
        'download_file',
        {
          id: id, 
          contactid: contacto
        },
        'POST'
      );
    });
  }

  sendmail_pr(emailSubject, emailBody, proyecto,emailInv) {
    var contacto = (localStorage.getItem('contactid')).split("x")[1];
    console.log(contacto)
    return new Promise((resolve) => {
      this.wsclient.doInvoke((res: any) => {
        if (res) {
          resolve({ success: true, result: res });
        } else {
          resolve({ success: false, error: this.wsclient.lastError() });
        }
      },
        'sendmail_pr',
        {
          emailSubject: emailSubject, 
          emailBody: emailBody, 
          proyecto: proyecto, 
          emailInv: emailInv, 
         
        },
        'GET'
      );
    });
  }

  getRelatedRecords(type?: string, id?:string,labels?:string) {
    var contacto = localStorage.getItem('contactid');
    return new Promise((resolve) => {
      this.wsclient.doInvoke((res: any) => {
        if (res) {
          resolve({ success: true, result: res });
        } else {
          resolve({ success: false, error: this.wsclient.lastError() });
        }
      },
        'retrieve_related',
        {
          id: id,
          relatedType: type,
          relatedLabel: labels
        },
        'GET'
      );
    });
  }
  
  get wsUrl(): string {
    var url = environment.url;
    if (url.charAt(url.length - 1) != '/') url += '/';
    return url;
  }
};
